export default __webpack_public_path__ + "static/media/NewPatientForm.da87e59c.pdf";